import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.css';
import Home from './pages/Home';

document.addEventListener("DOMContentLoaded", function() {
  const htmlElement = document.documentElement;
  const computedStyle = window.getComputedStyle(htmlElement);

  if (computedStyle.filter === "invert(1)") {
      htmlElement.classList.add("nightModeFixed");
  }
});

const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Home />
  </React.StrictMode>
);